import { PaApi } from '@/services/PaApi'

export const StatModule = {
  namespaced: true,

  state: {
    subscribers: {},
    subscriptions: {}
  },

  actions: {
    /*
      Nomenclature note:
        - Subscribers: user-based subscriber data.
        - Subscriptions: raw subscription data. Useful for fine-grained stats.
    */
    async getSubscriberStats ({ commit, state }) {
      commit('setLoading', true, { root: true })

      await PaApi().get(
        '/admin/stats/subscribers'
      ).then((resp) => {
        commit('storeSubscriberStats', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async getSubscriptionStats ({ commit, state }) {
      commit('setLoading', true, { root: true })

      await PaApi().get(
        '/admin/stats/subscriptions'
      ).then((resp) => {
        commit('storeSubscriptionStats', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    }
  },

  mutations: {
    storeSubscriberStats (state, payload) {
      state.subscribers = payload.data
    },

    storeSubscriptionStats (state, payload) {
      state.subscriptions = payload.data
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/StatModule.js